import type { AcEntity } from "~/sharedComponents/hierarchicalGrid/types";

type DurationPayload = { item: Pick<AcEntity, "Duration" | "DurationHours"> };
export const formDurationEventPayload = <T extends DurationPayload>({ item, ...rest }: T) => ({
    "was empty": !item.DurationHours && !item.Duration,
    ...rest,
});
